// Copyright 2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

enum MeetingStatus {
  Loading,
  Succeeded,
  Failed
}

export default MeetingStatus;
